"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _lastMileDeliveryPricerite = require("@/mixins/last-mile-delivery-pricerite/last-mile-delivery-pricerite");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDOrderSummaryComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderSummaryComponent, _Mixins);

  var _super = _createSuper(LMDOrderSummaryComponent);

  function LMDOrderSummaryComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDOrderSummaryComponent);
    _this = _super.apply(this, arguments);
    _this.isShowDetails = false;
    _this.groupedBy = 'projectCode';
    _this.groupedByFilters = ['zone', 'projectCode', 'customerCode', 'pickDistrict', 'dropDistrict'];
    return _this;
  }

  (0, _createClass2.default)(LMDOrderSummaryComponent, [{
    key: "onOrdersLengthChanges",
    value: function onOrdersLengthChanges(newVal) {
      if (newVal === 0) {
        this.isShowDetails = false;
      }
    }
  }, {
    key: "getCurrentTruckOrders",
    get: function get() {
      if (!this.$selectedTruck) {
        return '-';
      }

      return this.currPlanTruck ? this.currPlanTruck['orderId'].length : '-';
    }
  }, {
    key: "$planOrders",
    get: function get() {
      return this.$plan.orders;
    }
  }, {
    key: "groupedOrders",
    get: function get() {
      var _this2 = this;

      if (!this.helper.isUndefined(this.groupedBy) && this.$selectedOrders.length > 0) {
        var orders = this.groupedBy === 'pickDistrict' || this.groupedBy === 'dropDistrict' ? this.helper.groupBy(this.$selectedOrders, function (o) {
          if (_this2.groupedBy === 'pickDistrict') {
            return o.waypoints[0]['district'];
          }

          if (_this2.groupedBy === 'dropDistrict') {
            return o.waypoints[o.waypoints.length - 1]['district'];
          }
        }) : this.helper.groupBy(this.$selectedOrders, this.groupedBy);
        var mappedOrders = [];
        this.helper.forEach(orders, function (item, key) {
          mappedOrders.push({
            key: key,
            count: item.length,
            gw: _this2.helper.printThousandDecimal(_this2.helper.sumBy(item, function (o) {
              return parseFloat(o.weight);
            })),
            cbm: _this2.helper.printThousandDecimal(_this2.helper.sumBy(item, function (o) {
              return parseFloat(o.volume);
            }))
          });
        });
        return mappedOrders;
      }

      return [];
    }
  }, {
    key: "getPercentageColor",
    value: function getPercentageColor(result) {
      if (result <= 25) {
        return '#409EFF';
      } else if (result > 25 && result <= 50) {
        return '#67C23A';
      } else if (result > 50 && result <= 75) {
        return '#E6A23C';
      } else if (result > 75 && result < 100) {
        return '#F4A46B';
      } else {
        return '#F56C6C';
      }
    }
  }, {
    key: "percentage",
    value: function percentage(type) {
      var _this3 = this;

      var result = 0;

      if (type === 'gw') {
        var val = this.helper.sumBy(this.$selectedOrders.filter(function (order) {
          return !_this3.isInvalidOrder(order);
        }), function (o) {
          return parseFloat(o.weight);
        }) + this.getTruckCapacity('weight');
        var maxVal = this.helper.get(this.currTruck, 'weight', 0);
        result = maxVal === 0 || maxVal === 0.00 ? val !== 0 || val !== 0.00 ? 100 : 0 : parseFloat((val / (maxVal || 1) * 100).toFixed(5));
      }

      if (type === 'cbm') {
        var _val = this.helper.sumBy(this.$selectedOrders.filter(function (order) {
          return !_this3.isInvalidOrder(order);
        }), function (o) {
          return parseFloat(o.volume);
        }) + this.getTruckCapacity('volume');

        var _maxVal = this.helper.get(this.currTruck, 'volume', 0) * 1;

        result = _maxVal === 0 || _maxVal === 0.00 ? _val !== 0 || _val !== 0.00 ? 100 : 0 : parseFloat((_val / (_maxVal || 1) * 100).toFixed(5));
      }

      if (type === 'time') {
        var _val2 = this.getSelectedOrderCapacity('assemblyMinutes') + this.getTruckCapacity('assemblyMinutes');

        var _maxVal2 = this.helper.get(this.currTruck, 'assemblyMinutes', 0);

        result = _maxVal2 === 0 || _maxVal2 === 0.00 ? _val2 !== 0 || _val2 !== 0.00 ? 100 : 0 : parseFloat((_val2 / (_maxVal2 || 1) * 100).toFixed(5));
      }

      if (type === 'toteBoxDry') {
        var _val3 = this.getSelectedOrderCapacity('toteBoxDry') + this.getTruckCapacity('toteBoxDry');

        var _maxVal3 = this.helper.get(this.currTruck, 'capacity4', 0);

        result = _maxVal3 === 0 || _maxVal3 === 0.00 ? _val3 !== 0 || _val3 !== 0.00 ? 100 : 0 : parseFloat((_val3 / (_maxVal3 || 1) * 100).toFixed(5));
      }

      if (type === 'toteBoxWet') {
        var _val4 = this.getSelectedOrderCapacity('toteBoxWet') + this.getTruckCapacity('toteBoxWet');

        var _maxVal4 = this.helper.get(this.currTruck, 'capacity5', 0);

        result = _maxVal4 === 0 || _maxVal4 === 0.00 ? _val4 !== 0 || _val4 !== 0.00 ? 100 : 0 : parseFloat((_val4 / (_maxVal4 || 1) * 100).toFixed(5));
      }

      return result > 100 ? 100 : result;
    }
  }, {
    key: "percentageColor",
    value: function percentageColor(type) {
      return this.getPercentageColor(this.percentage(type));
    }
  }, {
    key: "getSelectedOrderCapacity",
    value: function getSelectedOrderCapacity(fieldName) {
      var _this4 = this;

      return fieldName === 'weight' || fieldName === 'volume' ? parseFloat(this.helper.sumBy(this.$selectedOrders.filter(function (order) {
        return !_this4.isInvalidOrder(order);
      }), function (o) {
        return parseFloat(o[fieldName]);
      }).toFixed(5)) : this.helper.sumBy(this.$selectedOrders.filter(function (order) {
        return !_this4.isInvalidOrder(order);
      }), function (o) {
        return o[fieldName];
      });
    }
  }, {
    key: "getTruckCapacity",
    value: function getTruckCapacity(fieldName) {
      var _this5 = this;

      var orderIds = this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === _this5.$selectedTruck;
      }), '0.orderId', null);

      if (this.helper.isUndefined(orderIds) || orderIds.length === 0) {
        return 0;
      }

      var orders = this.helper.filter(this.$planOrders, function (order) {
        return _this5.helper.includes(orderIds, order['id']);
      });

      if (orders.length === 0) {
        return 0;
      }

      return fieldName === 'weight' || fieldName === 'volume' ? parseFloat(this.helper.sumBy(orders, function (o) {
        return parseFloat(o[fieldName]);
      }).toFixed(5)) : this.helper.sumBy(orders, function (o) {
        return o[fieldName];
      });
    }
  }, {
    key: "getCurrentTruckOrdersField",
    value: function getCurrentTruckOrdersField(fieldName) {
      var _this6 = this;

      if (!this.$selectedTruck || this.helper.isUndefined(this.currPlanTruck)) {
        return 0;
      }

      var fOrders = this.$plan.orders.filter(function (o) {
        return _this6.currPlanTruck['orderId'].includes(o.id);
      });
      return this.helper.printThousandDecimal(this.helper.sumBy(fOrders, function (o) {
        return parseFloat(o[fieldName]) || 0;
      }));
    }
  }]);
  return LMDOrderSummaryComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDeliveryPricerite.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$selectedOrders.length')], LMDOrderSummaryComponent.prototype, "onOrdersLengthChanges", null);
LMDOrderSummaryComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderSummaryComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-progress': _elementUi.Progress,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-tooltip': _elementUi.Tooltip
  }
})], LMDOrderSummaryComponent);
var _default = LMDOrderSummaryComponent;
exports.default = _default;